import { Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface UpgradeNudgeProps {
  tier: 'pro' | 'premium';
  features?: string[];
}

const TIER_STYLES = {
  pro: {
    label: 'Pro',
    iconBg: 'bg-teal-500/20',
    iconColor: 'text-teal-400',
    badgeBg: 'bg-teal-500/20 border-teal-500/30',
    badgeText: 'text-teal-400',
    dotColor: 'bg-teal-400',
    btnClass: 'bg-teal-500 hover:bg-teal-400 text-slate-900',
  },
  premium: {
    label: 'Premium',
    iconBg: 'bg-purple-500/20',
    iconColor: 'text-purple-400',
    badgeBg: 'bg-purple-500/20 border-purple-500/30',
    badgeText: 'text-purple-400',
    dotColor: 'bg-purple-400',
    btnClass: 'bg-purple-500 hover:bg-purple-400 text-slate-100',
  },
} as const;

export function UpgradeNudge({ tier, features }: UpgradeNudgeProps) {
  const navigate = useNavigate();
  const s = TIER_STYLES[tier];

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6">
      <div className={`w-16 h-16 ${s.iconBg} rounded-full flex items-center justify-center mb-5`}>
        <Lock size={28} className={s.iconColor} />
      </div>
      <div className={`mb-4 px-3 py-1 rounded-full border ${s.badgeBg}`}>
        <span className={`text-xs font-semibold uppercase tracking-wider ${s.badgeText}`}>
          {s.label}
        </span>
      </div>
      <h3 className="text-xl font-semibold text-slate-100 mb-2">
        Upgrade to {s.label} to unlock this feature
      </h3>
      {features && features.length > 0 && (
        <ul className="text-left text-sm text-slate-300 space-y-2 mb-7 max-w-xs mt-3">
          {features.map((f, i) => (
            <li key={i} className="flex items-center gap-2">
              <span className={`w-1.5 h-1.5 ${s.dotColor} rounded-full flex-shrink-0`} />
              {f}
            </li>
          ))}
        </ul>
      )}
      <button
        onClick={() => navigate('/subscription')}
        className={`flex items-center gap-2 px-6 py-2.5 font-semibold rounded-lg transition-colors mt-5 ${s.btnClass}`}
      >
        Upgrade to {s.label}
        <ArrowRight size={16} />
      </button>
    </div>
  );
}
